import React, { useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Generic guest invitation page. Renders a static HTML invitation from /public
 * inside a full-viewport iframe so styles stay isolated and the URL stays clean.
 * Adds a noindex meta tag so search engines can't discover the page, and
 * records one "opened" event per browser session for the admin dashboard.
 */
const GuestInvite = ({ src, title, slug }) => {
  useEffect(() => {
    if (title) document.title = title;
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, [title]);

  useEffect(() => {
    if (!slug) return;
    const key = `rt_invite_seen_${slug}`;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, "1");
    } catch {
      // sessionStorage unavailable (private mode) - still record the view
    }
    axios.post(`${API}/invites/view`, { slug }).catch(() => {
      try {
        sessionStorage.removeItem(key);
      } catch {
        // ignore
      }
    });
  }, [slug]);

  return (
    <iframe
      title={title || "Wedding Invitation"}
      src={src}
      data-testid="guest-invite-frame"
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100vh",
        border: 0,
        margin: 0,
        padding: 0,
        background: "#f8f3ea",
      }}
    />
  );
};

export default GuestInvite;
